import React, { Component } from "react";

import { Card, Col, Icon, Row } from "antd";
import axios from "axios";
import { Bar, Doughnut } from "react-chartjs-2";

import "chartjs-plugin-deferred";
import CountUp from "react-countup";

import "./PartnerDashboard.css";

const { Meta } = Card;

class DetailedPartnerDashboard extends Component {
  state = {
    barChartData: {},
    ailmentChartData: {},
    deliveryLocationData: {},
    totalPatients: "",
    activePatients: "",
    pendingOrders: 48,
  };

  static defaultProps = {
    displayTitle: true,
    displayLegend: true,
    legendPosition: "right",
  };

  componentDidMount = () => {
    const { location, history } = this.props;

    if (!location.state) {
      history.push({
        pathname: "/managePartners",
      });
    } else {
      axios({
        method: "get",
        url: `/partners/${location.state.data[0].id}/ailment_split.json`,
        headers: { Authorization: sessionStorage.getItem("jwtToken") },
      }).then((response) => {
        // console.log(response.data);
        this.setState({ ailmentChartData: response.data });
        // console.log(JSON.stringify(ailmentChartData));
        const totalPatients = location.state.data[0].total_patients;

        const activePatients = location.state.data[0].active_patients;

        this.setState({ totalPatients, activePatients });
        this.getChartData();
      });
      // this.getChartData();
    }
  };

  getChartData() {
    // const ailments = {};

    // for (let locationIndex in this.props.location.state.data[0].locations) {
    //     // console.log(locationIndex,"location index");
    //     for (let ail in this.props.location.state.data[0].locations[locationIndex].ailment) {
    //         // console.log(this.props.location.state.data[0].locations[locationIndex].ailment)
    //         // console.log(ail,'ailment')
    //         if (ail in ailments) {
    //             ailments[ail] += this.props.location.state.data[0].locations[locationIndex].ailment[ail];
    //         } else {
    //             ailments[ail] = this.props.location.state.data[0].locations[locationIndex].ailment[ail];
    //         }
    //     }
    // }
    // console.log('ailment label',ailments);
    // console.log(this.state.ailmentChartData);
    const { ailmentChartData } = this.state;
    const ailmentLabels = Object.keys(ailmentChartData);
    const ailmentData = Object.values(ailmentChartData);
    // console.log(ailmentData);
    // console.log(ailmentLabels);
    this.setState({
      barChartData: {
        labels: ["Jan", "Feb", "Mar", "Apr", "May", "Jun"],
        datasets: [
          {
            fill: false,
            label: " Total Patient Growth",
            data: [12, 20, 35, 46, 50, 54],
            backgroundColor: [
              "#69c0ff",
              "#69c0ff",
              "#69c0ff",
              "#69c0ff",
              "#69c0ff",
              "#69c0ff",
              "#69c0ff",
              "#69c0ff",
              "#69c0ff",
              "#69c0ff",
              "#69c0ff",
              "#69c0ff",
            ],
            borderWidth: 1,
            borderColor: "#777",
            hoverBorderWidth: 3,
            hoverBorderColor: "#000",
          },
          {
            fill: false,
            label: " Active Patient Growth",
            data: [12, 16, 20, 39, 28, 30],
            backgroundColor: [
              "#f759ab",
              "#f759ab",
              "#f759ab",
              "#f759ab",
              "#f759ab",
              "#f759ab",
              "#f759ab",
              "#f759ab",
            ],
            borderWidth: 1,
            borderColor: "#777",
            hoverBorderWidth: 3,
            hoverBorderColor: "#000",
          },
        ],
      },
      ailmentChartData: {
        labels: ailmentLabels,
        datasets: [
          {
            fill: false,
            label: "Ailment Distribution",
            data: ailmentData,
            backgroundColor: [
              "#adc6ff",
              "#d3adf7",
              "#ffadd2",
              " #d3f261",
              "#ff9c6e",
              "#ff7875",
            ],
            borderWidth: 1,
            borderColor: "#777",
            hoverBorderWidth: 3,
            hoverBorderColor: "#000",
          },
        ],
      },
    });
  }

  render() {
    const {
      barChartData,
      totalPatients,
      activePatients,
      pendingOrders,
      ailmentChartData,
    } = this.state;
    const { location, displayLegend, legendPosition } = this.props;

    return (
      // <Admin>
      <div className="container-fluid">
        <Card className="mt-2 mb-2" bordered>
          <Bar
            data={barChartData}
            width={100}
            height={50}
            options={{
              plugins: {
                deferred: {
                  enabled: true,
                  xOffset: 150,
                  yOffset: "50%",
                  delay: 500,
                },
              },
              displayLegend: false,
              title: {
                display: "Patients Growth",
                text: location.state ? location.state.data[0].name : null,
                fontSize: 35,
              },
              scales: {
                yAxes: [
                  {
                    ticks: {
                      beginAtZero: true,
                    },
                  },
                ],
              },
              legend: {
                display: displayLegend,
                position: legendPosition,
                labels: { fontColor: "black" },
              },
            }}
          />
        </Card>
        <Row gutter={16}>
          <Col span={8}>
            <Card bodyStyle={{ backgroundColor: "#1890ff" }} hoverable bordered>
              <Meta
                className="text-light"
                title={
                  <span>
                    <Icon type="user" /> Total Patients
                  </span>
                }
              />
              <hr />
              <div className="m-2 text-center" style={{ height: "5vh" }}>
                <p className="text-light h1">
                  <CountUp start={0} end={totalPatients} />
                </p>
              </div>
            </Card>
          </Col>
          <Col span={8}>
            <Card bodyStyle={{ backgroundColor: "#eb2f96" }} hoverable bordered>
              <Meta
                className="text-light"
                title={
                  <span>
                    <Icon type="solution" /> Active Patients
                  </span>
                }
              />
              <hr />
              <div className="m-2 text-center" style={{ height: "5vh" }}>
                <p className="text-light h1">
                  <CountUp start={0} end={activePatients} />
                </p>
              </div>
            </Card>
          </Col>
          <Col span={8}>
            <Card bodyStyle={{ backgroundColor: "#1890ff" }} hoverable bordered>
              <Meta
                className="text-light"
                title={
                  <span>
                    <Icon type="medicine-box" /> Pending Deliveries
                  </span>
                }
              />
              <hr />
              <div className="m-2 text-center" style={{ height: "5vh" }}>
                <p className="text-light h1">
                  <CountUp start={0} end={pendingOrders} />
                </p>
              </div>
            </Card>
          </Col>
        </Row>
        <Row>
          <Col span={12}>
            <Card className="mt-2" hoverable bordered>
              <Doughnut
                className="m-5"
                data={ailmentChartData}
                width={100}
                height={50}
                options={{
                  plugins: {
                    deferred: {
                      enabled: false,
                      xOffset: 150,
                      yOffset: "100%",
                      delay: 100,
                    },
                  },
                  title: {
                    display: true,
                    text: "Ailment Distribution",
                    fontSize: 25,
                  },
                  scales: {
                    xAxes: [
                      {
                        gridLines: {
                          drawBorder: false,
                          display: false,
                          color: "rgba(0, 0, 0, 0)",
                        },
                        ticks: {
                          display: false,
                        },
                        display: false,
                      },
                    ],
                    yAxes: [
                      {
                        gridLines: {
                          drawBorder: false,
                          diplay: false,
                          color: "rgba(0, 0, 0, 0)",
                        },
                        ticks: {
                          display: false,
                          beginAtZero: true,
                        },
                      },
                    ],
                  },
                  legend: {
                    display: true,
                    position: "right",
                    labels: { fontColor: "rgba(255,99,132,1)" },
                  },
                }}
              />
            </Card>
          </Col>
          <Col span={12} />
        </Row>
      </div>
      // </Admin>
    );
  }
}

export default DetailedPartnerDashboard;



// WEBPACK FOOTER //
// ./src/component/Partners/DetailedPartnerDashboard.js